// extracted by mini-css-extract-plugin
export default {"PageContacts":"PageContacts_PageContacts__6aW5s"};